import React, { useRef, useState } from 'react';
import { uploadImage } from '../api';

export default function ImageUploadField({
  label,
  value,
  onChange,
  folder,
  description,
  allowRelativeUrl = false,
}) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');

  const handleFileSelect = async (event) => {
    const file = event.target.files?.[0];
    if (!file) {
      return;
    }

    setUploading(true);
    setError('');

    try {
      const dataUrl = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(new Error('读取图片失败'));
        reader.readAsDataURL(file);
      });

      const res = await uploadImage({
        filename: file.name,
        dataUrl,
        folder,
      });

      onChange(res.data.url);
    } catch (uploadError) {
      console.error('Image upload failed:', uploadError);
      setError(uploadError?.response?.data?.error || '图片上传失败，请稍后重试');
    } finally {
      setUploading(false);
      if (inputRef.current) {
        inputRef.current.value = '';
      }
    }
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between gap-4">
        <div>
          <label className="block text-white font-semibold mb-1">{label}</label>
          {description && <p className="text-sm text-gray-400">{description}</p>}
        </div>
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          disabled={uploading}
          className="rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-blue-700 disabled:opacity-60"
        >
          {uploading ? '上传中...' : '上传图片'}
        </button>
      </div>

      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        onChange={handleFileSelect}
        className="hidden"
      />

      <input
        type={allowRelativeUrl ? 'text' : 'url'}
        value={value || ''}
        onChange={(event) => onChange(event.target.value)}
        placeholder="也可以直接粘贴图片 URL"
        className="w-full rounded-lg border border-gray-700 bg-dark-secondary px-4 py-3 text-white focus:outline-none focus:border-blue-500"
      />

      {value && (
        <div className="overflow-hidden rounded-xl border border-gray-700 bg-dark">
          <img src={value} alt={label} className="h-48 w-full object-cover" />
        </div>
      )}

      {error && (
        <div className="rounded-lg border border-red-800 bg-red-950/40 px-4 py-3 text-sm text-red-200">
          {error}
        </div>
      )}
    </div>
  );
}
